var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isFilteredNavDataEmpty)?_c('div',[_c('span',{staticClass:"noSearchResult"},[_vm._v("No Search Results")])]):_c('div',{staticClass:"nav-list--clickable-section-header"},[_c('nav-list',{attrs:{"navData":_vm.filteredNavData,"contentType":_vm.contentType}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }